import React from 'react';

const PersonalDataForm = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="text-gray-400 text-sm mb-2 block">Nome e Cognome *</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full bg-[#0A0A0A] border border-[#2A2A2A] text-white px-4 py-3 focus:border-[#FFCC00] focus:outline-none transition-colors"
          placeholder="Mario Rossi"
          data-testid="booking-name"
        />
      </div>
      <div>
        <label className="text-gray-400 text-sm mb-2 block">Email *</label>
        <input
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className="w-full bg-[#0A0A0A] border border-[#2A2A2A] text-white px-4 py-3 focus:border-[#FFCC00] focus:outline-none transition-colors"
          placeholder="mario@email.com"
          data-testid="booking-email"
        />
      </div>
      <div>
        <label className="text-gray-400 text-sm mb-2 block">Telefono *</label>
        <input
          type="tel"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          className="w-full bg-[#0A0A0A] border border-[#2A2A2A] text-white px-4 py-3 focus:border-[#FFCC00] focus:outline-none transition-colors"
          placeholder="+39 333 1234567"
          data-testid="booking-phone"
        />
      </div>
    </div>
  );
};

export default PersonalDataForm;
